import { createSelector } from 'reselect'

import productTypes from 'helpers/enums/productTypes'
import userRoleTypes from 'helpers/enums/userRoleTypes'
import platformTypes from 'helpers/enums/platformTypes'
import userBadgeSelector from 'redux/selectors/user/user_badge_selector'
import userFullNameSelector from 'redux/selectors/user/user_full_name_selector'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.NOTIFICATION_PREFERENCES,
])

const getUserData = state => state.user
const uiSelector = state => state.ui

const getNavigationMenuMainData = createSelector(
	[userBadgeSelector, getUserData, uiSelector, userFullNameSelector, featureFlagsSelector],
	(userBadge, userData, uiData, userFullName, featureFlags) => {
		const canManage = userData.data.canManage || false

		const shouldShowUpgradeButton =
			userData.data.productId !== productTypes.SCHOOL &&
			userData.data.productId !== productTypes.DISTRICT &&
			!canManage

		let manageLink
		if (canManage &&
			userRoleTypes.SCHOOL_ADMIN !== userData.data.roleId &&
			userRoleTypes.DISTRICT_ADMIN !== userData.data.roleId &&
			userData.data.account &&
			userData.data.account.manage) {
			manageLink = userData.data.account.manage.link
		} else {
			manageLink = ''
		}

		const isImpersonateSession = userData.extra ?
			userData.extra.isImpersonateSession : false

		const shouldShowProfileImageButton = uiData.platform === platformTypes.WEB
		const shouldShowNotificationPreferencesView = featureFlags[featureFlagsTypes.NOTIFICATION_PREFERENCES]

		return {
			userData: {
				name: userFullName,
				email: userData.data.email || '',
				image: userData.data.image || '',
				isImpersonateSession,
			},
			upgradeRedirectLink: userBadge.buttonRedirect,
			shouldShowUpgradeButton,
			badgeProduct: userBadge.badgeProduct,
			shouldShowManageButton: !!manageLink,
			manageLink,
			shouldShowProfileImageButton,
			shouldShowNotificationPreferencesView,
		}
	}
)

export default getNavigationMenuMainData
